import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export type Role = {
  id: number
  group_name: string
  name: string
  min_unit_price: number | null
  max_unit_price: number | null
}

type GetRolesResponse = {
  roles: Role[]
}

export function useRoles() {
  return useQuery({
    queryKey: queryKeys.roles,
    queryFn: () =>
      apiFetch<GetRolesResponse>('/api/roles', {
        method: 'GET',
      }),
    staleTime: 60 * 60 * 1000,
  })
}
